import { SkipNavContent } from '@reach/skip-nav'

export default SkipNavContent
